import { css } from '@emotion/react';
import { createCalendar } from '../function/createCalendar';

export const CalendarTableM = (props: CalendarTableMProps) => {
  return (
    <table className='w-full' css={calendar}>
      <caption className='mb-[16px] text-[1.7rem]'>{`${props.month + 1}月`}</caption>
      <thead>
        <tr>
          <th>日</th>
          <th>月</th>
          <th>火</th>
          <th>水</th>
          <th>木</th>
          <th>金</th>
          <th>土</th>
        </tr>
      </thead>
      <tbody
        dangerouslySetInnerHTML={createCalendar(props.data, new Date(props.year, props.month, 1))}
      />
    </table>
  );
};

const calendar = css`
  margin: 0 10px 30px;
  @media (min-width: 768px) {
    margin: 0;
  }
  th,
  td {
    border: 1px solid #fff;
    padding: 4px 4px 7px;
    font-size: 18px;
    text-align: center;
  }
  th {
    font-size: 1.2rem;
    color: #8f8f8f;
  }
  td {
    p {
      line-height: 1;
    }
  }
  .noBox {
    font-size: 12px;
    font-style: italic;
    margin-top: 3px;
  }
  .no {
    font-size: 10px;
  }
  .color-0 {
    background-color: #fcfcfc;
    * {
      visibility: hidden;
    }
  }
  .color-1 {
    background-color: #ddcb8f;
  }
  .color-2 {
    background-color: #f77f7f;
  }
  .color-3 {
    background-color: #f5f6f7;
  }
  .color-4 {
    background-color: #7db6f7;
  }
  .color-9 {
    background-color: #cacbcc;
  }
  .no-0 {
    .noBox {
      visibility: hidden;
    }
  }
`;
